// Lucide icon: book-open-text (https://lucide.dev/icons/book-open-text)
import { BookOpenText } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconCatalog = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <BookOpenText />
    </IconComponentStyled>
  )
}
